import { render, staticRenderFns } from "./InstitucionalFooter.vue?vue&type=template&id=1e32b9f7&"
import script from "./InstitucionalFooter.vue?vue&type=script&lang=js&"
export * from "./InstitucionalFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports